/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.innerHTML + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - File Upload
  ========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".ginput_container_fileupload");

  containers.forEach(container => {
    const button = container.querySelector(".gform_button_select_files");

    if (button) {
      container.addEventListener("click", function (e) {
        // Avoid triggering if the actual button was clicked
        if (!e.target.closest(".gform_button_select_files")) {
          button.click();
        }
      });
    }
  });
});

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
    MODULE - Featured Companies, "Load More"
    ========================================================================== */

const featuredCompanies = document.querySelector(".module--featured-companies");

const featuredCompanies__loadMore = function () {
  if (!featuredCompanies) {
    return;
  }

  const loadMoreBtn = featuredCompanies.querySelector(".load-more");
  const loadMoreItems = featuredCompanies.querySelectorAll(".load-more__items");
  const loadMoreItemsCount = loadMoreItems.length;
  const itemsToShowInitially = 8;

  // Initially hide all items except for the first 8
  for (let i = 0; i < loadMoreItemsCount; i++) {
    if (i < itemsToShowInitially) {
      loadMoreItems[i].classList.add("load-more__items--active");
    } else {
      loadMoreItems[i].classList.remove("load-more__items--active");
    }
  }

  // Show load-more button if there are hidden items
  if (loadMoreItemsCount > itemsToShowInitially) {
    loadMoreBtn.style.display = "block";
  } else {
    loadMoreBtn.style.display = "none";
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {
      let activeItemsCount = document.querySelectorAll(".load-more__items--active").length;

      // Show next 8 items
      for (let i = activeItemsCount; i < activeItemsCount + itemsToShowInitially; i++) {
        if (loadMoreItems[i]) {
          loadMoreItems[i].classList.add("load-more__items--active");
        }
      }

      // Check if there are more items to load
      activeItemsCount = document.querySelectorAll(".load-more__items--active").length;
      if (activeItemsCount >= loadMoreItemsCount) {
        loadMoreBtn.style.display = "none"; // Hide the button when all items are visible
      }
    });
  }
};

featuredCompanies__loadMore();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
	NAVIGATION DESKTOP - sitenav--right hide when 50% footer is visible on scroll
	========================================================================== */

const sitenavRight = document.querySelector(".sitenav--right");
const footer = document.querySelector(".sitefooter");

const sitenavRightHideOnScroll = () => {
  if (!sitenavRight || !footer) {
    return;
  } // prevent errors if either element is missing

  const rect = footer.getBoundingClientRect();
  const halfVisible = rect.top + rect.height / 3;

  if (halfVisible < window.innerHeight) {
    sitenavRight.classList.add("sitenav--hide");
  } else {
    sitenavRight.classList.remove("sitenav--hide");
  }
};

const sitenavRightinit = function () {
  // Check if elements exist
  if (!sitenavRight || !footer) {
    return;
  }
  // Initial check
  sitenavRightHideOnScroll();

  // Event listeners
  window.addEventListener("scroll", sitenavRightHideOnScroll);
  window.addEventListener("resize", sitenavRightHideOnScroll); // optional: handle resizes too
};

sitenavRightinit();

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();

/*  ==========================================================================
	FORM - Input Label Animation
	========================================================================== */

const inputsInit = function () {
  const inputs = document.querySelectorAll("input, textarea, select");
  if (!inputs) {
    return;
  }

  inputs.forEach(input => {
    let label = input.previousElementSibling;
    if (!label || label.tagName.toLowerCase() !== "label") {
      label = input.parentElement.previousElementSibling;
    }

    const shouldFloat = () => {
      if (input.tagName.toLowerCase() === "select") {
        if (input.value.trim() === "" && input.selectedIndex === -1) {
          return false;
        } else if (input.value.trim() === "" && input.selectedIndex === 0) {
          return true;
        }
      }
      return input.value.trim() !== ""; // Inputs & textareas should float if they have text
    };

    // Listen for input changes (typing, pasting, deleting)
    input.addEventListener("input", function () {
      if (shouldFloat() && label) {
        label.classList.add("label--focused");
        if (input.tagName.toLowerCase() === "textarea") {
          input.parentElement.classList.add("input--filled");
        } else {
          input.classList.add("input--filled");
        }
      } else if (!shouldFloat() && label) {
        label.classList.remove("label--focused");
        if (input.tagName.toLowerCase() === "textarea") {
          input.parentElement.classList.remove("input--filled");
        } else {
          input.classList.remove("input--filled");
        }
      }
    });

    // Ensure select dropdowns update the label
    if (input.tagName.toLowerCase() === "select") {
      input.addEventListener("change", function () {
        if (shouldFloat() && label) {
          label.classList.add("label--focused");
        } else if (!shouldFloat() && label) {
          label.classList.remove("label--focused");
        }
      });
    }

    // Apply label positioning on page load (for pre-filled values)
    if (shouldFloat() && label) {
      label.classList.add("label--focused");
    }
  });

  // EXTRA: Handle Gravity Forms multi-file fields
  const fileUploadFields = document.querySelectorAll(".gfield--type-fileupload");

  fileUploadFields.forEach(field => {
    const fileInput = field.querySelector('input[type="file"]');
    const previewList = field.querySelector(".ginput_preview_list");
    const label = field.querySelector("label");

    if (!fileInput || !previewList) {
      return;
    }

    const updateLabel = () => {
      const hasFiles = previewList.children.length > 0;

      if (hasFiles) {
        label.classList.add("label--focused");
        field.classList.add("input--filled");

        setTimeout(() => {
          const deleteFile = field.querySelector(".gform_delete_file");

          deleteFile.addEventListener("click", () => {
            setTimeout(updateLabel, 100);
          });
        }, 100);
      } else {
        label.classList.remove("label--focused");
        field.classList.remove("input--filled");
      }
    };

    fileInput.addEventListener("change", () => {
      setTimeout(updateLabel, 100);
    });

    // Also update on page load in case files are preloaded
    updateLabel();
  });

  //EXTRA: Handle Gravity Forms list fields
  const listFields = document.querySelectorAll(".gfield--type-list");

  listFields.forEach(field => {
    const inputs = field.querySelectorAll("input");
    const label = field.querySelector("legend");

    inputs.forEach(input => {
      const shouldFloat = () => {
        return input.value.trim() !== ""; // Inputs & textareas should float if they have text
      };

      // Listen for input changes (typing, pasting, deleting)
      input.addEventListener("input", function () {
        if (shouldFloat() && label) {
          label.classList.add("label--focused");
          field.classList.add("input--filled");
        } else if (!shouldFloat() && label) {
          label.classList.remove("label--focused");
          field.classList.remove("input--filled");
        }
      });
    });
  });
};

// Run on page load
document.addEventListener("DOMContentLoaded", inputsInit);
// // Re-run when Gravity Forms loads via AJAX
jQuery(document).on("gform_post_render", function () {
  setTimeout(inputsInit, 50); // small delay helps when DOM update isn't instant
});

/*  ==========================================================================
  FORM - Input enforce “undeletable” £ prefixes 
  ========================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll('.currency-prefix input[type="text"]');

  inputs.forEach(function (input) {
    // Show only placeholder until typing
    if (!input.value.startsWith("£") && input.value.trim() === "") {
      input.value = "";
    } else if (!input.value.startsWith("£")) {
      input.value = "£";
    }

    // On focus, add £ if empty
    input.addEventListener("focus", function () {
      if (!input.value.startsWith("£")) {
        input.value = "£";
      }
    });

    // Prevent deleting the £
    input.addEventListener("keydown", function (e) {
      const caretPos = input.selectionStart;
      if ((e.key === "Backspace" && caretPos <= 1) || (e.key === "Delete" && caretPos === 0)) {
        e.preventDefault();
      }
    });

    // On paste, keep the £
    input.addEventListener("paste", function (e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const clean = pasted.replace(/^£+/g, "");
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const current = input.value;
      const newVal = current.slice(0, start) + clean + current.slice(end);
      input.value = "£" + newVal.replace(/^£+/g, "");
    });

    // On blur, ensure £ still there
    input.addEventListener("blur", function () {
      if (input.value === "£") {
        input.value = ""; // Leave empty to allow placeholder
      } else if (!input.value.startsWith("£")) {
        input.value = "£" + input.value.replace(/^£+/g, "");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const prefix = "https://";
  const inputs = document.querySelectorAll('.url-prefix input[type="url"]');

  inputs.forEach(function (input) {
    // Add prefix if missing on focus
    input.addEventListener("focus", function () {
      if (!input.value.startsWith(prefix)) {
        input.value = prefix;
        setCaretToEnd(input);
      }
    });

    // Prevent deleting the prefix
    input.addEventListener("keydown", function (e) {
      const caretPos = input.selectionStart;
      if ((e.key === "Backspace" && caretPos <= prefix.length) || (e.key === "Delete" && caretPos < prefix.length)) {
        e.preventDefault();
      }
    });

    // Ensure prefix remains on blur
    input.addEventListener("blur", function () {
      if (!input.value.startsWith(prefix) && input.value.trim() !== "") {
        input.value = prefix + input.value.replace(/^https?:\/\//i, "");
      }
    });

    // Handle paste: preserve prefix
    input.addEventListener("paste", function (e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const clean = pasted.replace(/^https?:\/\//i, "");
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const current = input.value;
      const newVal = current.slice(0, start) + clean + current.slice(end);
      input.value = prefix + newVal.replace(/^https?:\/\//i, "");
    });
  });

  // Helper: Set caret after prefix
  function setCaretToEnd(el) {
    requestAnimationFrame(() => {
      el.setSelectionRange(el.value.length, el.value.length);
    });
  }
});

function shuffleCompaniesInit() {
  var Shuffle = window.Shuffle;
  var element = document.querySelector(".companies.shufflejs");

  if (element === null) {
    return;
  }

  var shuffleInstance = new Shuffle(element, {
    itemSelector: ".col"
  });

  var buttons = document.querySelectorAll(".filters__item");
  var activeFilters = new Set();

  initFiltersFromURL(activeFilters, shuffleInstance);
  setupFilterClickHandlers(buttons, activeFilters, shuffleInstance);
}

function initFiltersFromURL(activeFilters, shuffleInstance) {
  var params = new URLSearchParams(window.location.search);
  var urlFilters = params.get("filters");

  if (urlFilters !== null) {
    var filters = urlFilters.split(",");

    for (var i = 0; i < filters.length; i++) {
      var group = filters[i];
      activeFilters.add(group);

      var filterButton = document.querySelector('.filters__item[data-group="' + group + '"]');
      if (filterButton !== null) {
        filterButton.classList.add("active");
      }
    }

    applyFilters(activeFilters, shuffleInstance);
  } else {
    var allButton = document.querySelector('.filters__item[data-group="all"]');
    if (allButton !== null) {
      allButton.classList.add("active");
    }
  }
}

function setupFilterClickHandlers(buttons, activeFilters, shuffleInstance) {
  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];
    attachFilterClickHandler(button, activeFilters, shuffleInstance, buttons);
  }
}

function attachFilterClickHandler(button, activeFilters, shuffleInstance, buttons) {
  button.addEventListener("click", function () {
    var group = button.getAttribute("data-group");

    if (group === "all") {
      resetFilters(buttons, activeFilters, shuffleInstance);
    } else {
      toggleFilter(button, group, activeFilters);

      var allBtn = document.querySelector('.filters__item[data-group="all"]');
      if (allBtn !== null) {
        allBtn.classList.remove("active");
      }

      if (activeFilters.size === 0) {
        if (allBtn !== null) {
          allBtn.classList.add("active");
        }
        shuffleInstance.filter();
      } else {
        applyFilters(activeFilters, shuffleInstance);
      }
    }

    updateURL(activeFilters);
  });
}

function toggleFilter(button, group, activeFilters) {
  if (activeFilters.has(group)) {
    activeFilters.delete(group);
    button.classList.remove("active");
  } else {
    activeFilters.add(group);
    button.classList.add("active");
  }
}

function resetFilters(buttons, activeFilters, shuffleInstance) {
  activeFilters.clear();

  for (var i = 0; i < buttons.length; i++) {
    buttons[i].classList.remove("active");
  }

  var allButton = document.querySelector('.filters__item[data-group="all"]');
  if (allButton !== null) {
    allButton.classList.add("active");
  }

  shuffleInstance.filter(); // Show all
}

function applyFilters(activeFilters, shuffleInstance) {
  shuffleInstance.filter(function (element) {
    var groupsAttr = element.getAttribute("data-groups");

    if (groupsAttr === null) {
      return false;
    }

    try {
      var itemGroups = JSON.parse(groupsAttr);
      var filterArray = Array.from(activeFilters);

      for (var i = 0; i < filterArray.length; i++) {
        if (itemGroups.indexOf(filterArray[i]) !== -1) {
          return true;
        }
      }

      return false;
    } catch (e) {
      return false;
    }
  });
}

function updateURL(activeFilters) {
  var url = new URL(window.location);

  if (activeFilters.size === 0) {
    url.searchParams.delete("filters");
  } else {
    var filtersString = Array.from(activeFilters).join(",");
    url.searchParams.set("filters", filtersString);
  }

  window.history.replaceState({}, "", url);
}

// Initialize
shuffleCompaniesInit();
